import store from "../store.js";
import keviApi from "../keviApi";
import Vue from "vue";
import InboxStore from "./inbox.store";

const state = () => ({
    status: "loading",
    data: {
        notes: [],
    },
});

const actions = {
    get({ commit }, id) {
        commit("setStatus", "loading");
        let options = keviApi.getOptions("inbox/message/" + id);
        Vue.http(options)
            .then((response) => {
                commit("setData", response.body);
            })
            .finally(() => {
                commit("setStatus", "ready");
            });
    },
    applyTag({ state, commit }, payload) {
        if (!state.data.id) {
            return null;
        }
        const body =
            typeof payload === "object" && payload !== null
                ? payload.tag_id
                    ? { tag_id: payload.tag_id }
                    : { name: payload.name }
                : { tag_id: payload };
        let options = keviApi.getOptions(
            "answers/" + state.data.id + "/tags",
            "POST",
            body,
        );
        return Vue.http(options).then((response) => {
            let data = JSON.parse(JSON.stringify(state.data));
            data.tags = response.body.tags;
            if (response.body.tag) {
                const available = data.available_tags || [];
                if (
                    !available.some(
                        (tag) => String(tag.id) === String(response.body.tag.id),
                    )
                ) {
                    data.available_tags = available.concat([response.body.tag]);
                }
            }
            commit("setData", data);
            InboxStore.commit("inbox/setMessageTags", {
                messageId: state.data.id,
                tags: data.tags,
            });
            return response.body;
        });
    },
    removeTag({ state, commit }, tagId) {
        if (!state.data.id) {
            return null;
        }
        let options = keviApi.getOptions(
            "answers/" + state.data.id + "/tags/" + tagId,
            "DELETE",
        );
        return Vue.http(options).then((response) => {
            let data = JSON.parse(JSON.stringify(state.data));
            data.tags = response.body.tags;
            commit("setData", data);
            InboxStore.commit("inbox/setMessageTags", {
                messageId: state.data.id,
                tags: data.tags,
            });
            return response.body;
        });
    },
    addNote({ commit, state }, note) {
        if (!state.data.id) {
            return null;
        }
        let options = keviApi.getOptions(
            "inbox/message/" + state.data.id + "/addNote",
            "PUT",
            { note },
        );
        return Vue.http(options).then((response) => {
            let data = JSON.parse(JSON.stringify(state.data));
            data.notes.push(response.body);
            commit("setData", data);
        });
    },
    updateNote({ commit, state }, { noteId, note }) {
        if (!state.data.id || !noteId) {
            return null;
        }
        let options = keviApi.getOptions(
            "inbox/message/" + state.data.id + "/updateNote/" + noteId,
            "PUT",
            { note },
        );
        return Vue.http(options).then((response) => {
            let data = JSON.parse(JSON.stringify(state.data));
            const noteIndex = data.notes.findIndex(n => n.id == noteId);
            if (noteIndex !== -1) {
                data.notes[noteIndex] = response.body;
            }
            commit("setData", data);
        });
    },
    deleteNote({ commit, state }, { noteId }) {
        if (!state.data.id || !noteId) {
            return null;
        }
        let options = keviApi.getOptions(
            "inbox/message/" + state.data.id + "/deleteNote/" + noteId,
            "DELETE"
        );
        return Vue.http(options).then(() => {
            let data = JSON.parse(JSON.stringify(state.data));
            data.notes = data.notes.filter(n => n.id != noteId);
            commit("setData", data);
        });
    },
    editAnswers({ state }, questions) {
        if (!state.data.id) {
            return null;
        }
        let options = keviApi.getOptions(
            "answers/" + state.data.id,
            "POST",
            { questions },
        );
        return Vue.http(options).then((response) => response.body);
    },
    duplicate({ state }, questions = {}) {
        if (!state.data.id) {
            return null;
        }
        let options = keviApi.getOptions(
            "answers/" + state.data.id + "/duplicate",
            "POST",
            { questions },
        );
        return Vue.http(options).then((response) => response.body);
    },
    softDelete({ state }) {
        if (!state.data.id) {
            return null;
        }
        let options = keviApi.getOptions(
            "answers/" + state.data.id,
            "DELETE",
        );
        return Vue.http(options).then((response) => response.body);
    },
};

const mutations = {
    setStatus(state, status) {
        state.status = status;
    },
    setData(state, data) {
        state.data = JSON.parse(JSON.stringify(data));
    },
};

store.registerModule("message", {
    namespaced: true,
    state,
    actions,
    mutations,
});

export default store;
